import { render, staticRenderFns } from "./SearchResultConversationsList.vue?vue&type=template&id=8681fb24&"
import script from "./SearchResultConversationsList.vue?vue&type=script&lang=js&"
export * from "./SearchResultConversationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8681fb24')) {
      api.createRecord('8681fb24', component.options)
    } else {
      api.reload('8681fb24', component.options)
    }
    module.hot.accept("./SearchResultConversationsList.vue?vue&type=template&id=8681fb24&", function () {
      api.rerender('8681fb24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/search/components/SearchResultConversationsList.vue"
export default component.exports